/**
 * Sanitize user-supplied SVG for **local animated icon** mode (SMIL / CSS-only;
 * no scripts or event handlers).
 */
export function sanitizeLocalAnimatedSvgMarkup(raw: string): string | null {
	const trimmed = raw.trim();
	if (!/^<svg\b/i.test(trimmed)) {
		return null;
	}
	let s = trimmed.replace(/<script\b[\s\S]*?<\/script>/gi, "");
	s = s.replace(/<style\b[\s\S]*?<\/style>/gi, "");
	s = s.replace(/<foreignObject\b[\s\S]*?<\/foreignObject>/gi, "");
	s = s.replace(/\s(on[a-z]+)\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, "");
	s = s.replace(/\bhref\s*=\s*["']?\s*javascript:/gi, 'href="#"');
	s = s.replace(/\bxlink:href\s*=\s*["']?\s*javascript:/gi, 'xlink:href="#"');
	return s;
}
